module.exports = __webpack_public_path__ + "resources/img/nhn_toast.dbb5c485be880e6a8d6a815ca5028e61.png";